// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutCatsText_wrapper__1GiHx","mainText":"AboutCatsText_mainText__3D4qN","title":"AboutCatsText_title__1FGfp","rep":"AboutCatsText_rep__3utg8"};